import React, { useState,useEffect } from "react";
import Slider from "react-slick";
import { Link } from "gatsby";
import { isIOS } from 'react-device-detect';
import "./LocalLiving.scss";
import HTMLReactParser from "html-react-parser";
import PlayVideo from "../PlayVideo/PlayVideo";

const LocalLiving = (props) => {
    const [isPlay, setPlay] = useState(false);
    var settings = {
        dots: false,
        arrows: false,
        autoplay: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        centerMode:true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode:false
                }
            },
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1.5,
                }
            },
            {
                breakpoint: 2000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1.3,
                }
            }
        ]
    };
    const [renderComponent, setRenderComponent] = useState(false);
    useEffect(() => {
        if (isIOS) {
          setRenderComponent(true)
        }
        else {
        window.addEventListener("mousemove", () => {
        if (renderComponent === false) {
          setRenderComponent(true)
        }
        })
        window.addEventListener("touchmove", () => {
            if (renderComponent === false) {
            setRenderComponent(true)
            }
        })
        window.addEventListener("keypress", () => {
            if (renderComponent === false) {
            setRenderComponent(true)
            }
        })}
    }, [])

    return (
        <React.Fragment>
            {/* <section className="Local-living" style={{ backgroundImage: `url(${props?.data?.Tile_Image.url})`}}> */}
            <section className="Local-living">
                <Slider className="slick-arrow" {...settings}>
                    <div className="left-block cursor-pointer">
                        <Link to="/local-living/">
                            <h3>{props?.data?.Sm_Title} →</h3>
                        </Link>
                        {props?.data?.Content && <span className="description">
                            {HTMLReactParser(props?.data?.Content)}
                        </span>}
                    </div>
                    <div className="left-block cursor-pointer">
                        <Link to="/local-living/">
                            <h3>{props?.data?.Sm_Title} →</h3>
                        </Link>
                        {props?.data?.Content && <span className="description">
                            {HTMLReactParser(props?.data?.Content)}
                        </span>}
                    </div>
                    <div className="left-block cursor-pointer">
                        <Link to="/local-living/">
                            <h3>{props?.data?.Sm_Title} →</h3>
                        </Link>
                        {props?.data?.Content && <span className="description">
                            <b>{HTMLReactParser(props?.data?.Content)}</b>
                        </span>}
                    </div>
                </Slider>
                <div className="video-container">
                    {renderComponent &&
                    <video
                        data-autoplay
                        playsinline="true"
                        autoplay="true"
                        muted="true"
                        loop="true"
                        preload="metadata"
                        className="h-100 w-100 object-fit-cover"
                        loading="lazy"
                    >
                        <source src={props?.data?.Short_Video?.url} type="video/mp4" />
                    </video>}
                </div>
                {(props?.data?.Video_Url && !isPlay) && <button type="button" className="play-btn" onClick={() => { setPlay(true) }}>
                    <i className="video-icon"></i>
                </button>}
                
                {(props?.data?.Video_Url && isPlay) && <div className="fullscreen-video">
                    {isPlay && 
                        <React.Fragment>
                            <div className="d-block">
                                <PlayVideo
                                    isOpen={isPlay}
                                    videoId={props?.data?.Video_Url}
                                    stopPlay={setPlay}
                                    width={'100%'} height={'100%'}
                                    fullscreen={true}
                                />
                            </div>
                        </React.Fragment>
                    }
                </div>}
            </section>
        </React.Fragment>
    );
};

export default LocalLiving;
